export enum ChartTypeEnum {
  pie = 'Pie Chart',
  bar = 'Bar Chart',
  horizontalBar = 'Horizontal Bar Chart',
  labelRotationBar = 'Label Rotation Bar Chart',
}
